import { ebGroupe } from './groupe';
import { EbEtablissement } from './etablissement';
import { Statique } from '../utils/statique';
import { EbLien } from './lien';
export class EbCompagnie {
  ebCompagnieNum: number;
  nom: string;
  siren: string;
  ebGroupe: ebGroupe;
  listEtablissements: Array<EbEtablissement>;
  code: string;
  compagnieRole: number;
  groupeName: string;
  addCmdConfig: any;
  scenario: number;
  listLiens: Array<EbLien>
  agenceParDefaut: EbEtablissement;


  constructor() {
    this.ebCompagnieNum = null;
    this.nom = null;
    this.siren = null;
    this.ebGroupe = new ebGroupe();
    this.listEtablissements = new Array<EbEtablissement>();
    this.code = null;
    this.compagnieRole = null;
    this.groupeName = null;
    this.addCmdConfig = Statique.getDeffaultParamCommande()
    this.scenario = null;
    this.listLiens = new Array<EbLien>();
    this.agenceParDefaut = null;
  }

  constructorCopy(ebCompagnie: EbCompagnie) {
    this.constructor();
    this.ebCompagnieNum = ebCompagnie.ebCompagnieNum;
    this.nom = ebCompagnie.nom;
    this.siren = ebCompagnie.siren;
    this.ebGroupe = ebCompagnie.ebGroupe;
    this.listEtablissementsCopy(ebCompagnie.listEtablissements);
    this.code = ebCompagnie.code;
    this.compagnieRole = ebCompagnie.compagnieRole;
    this.groupeName = ebCompagnie.groupeName;
    this.addCmdConfig = ebCompagnie.addCmdConfig;
    this.scenario = ebCompagnie.scenario;
    this.listLiensCopy(ebCompagnie.listLiens);
    this.agenceParDefaut= JSON.parse(JSON.stringify(ebCompagnie.agenceParDefaut));
  }
  
  listLiensCopy(listLiens: Array<EbLien>) {
    let _lien: EbLien;
    if (listLiens !== undefined && listLiens !== null && listLiens.length !== 0) {

      for (let lien of listLiens) {
        _lien = new EbLien();
        _lien.constructorCopy(lien);
        this.listLiens.push(_lien);
      }
    }
    else {
      this.listLiens = new Array<EbLien>();
    }
  }

  listEtablissementsCopy(listEtablissements: Array<EbEtablissement>) {
    let _etablissement;
    if (listEtablissements !== undefined && listEtablissements !== null && listEtablissements.length !== 0) {
      for (let etablissement of listEtablissements) {
        _etablissement = new EbEtablissement();
        _etablissement.constructorCopy(etablissement);
        this.listEtablissements.push(_etablissement);
      }
    }
    else {
      this.listEtablissements = new Array<EbEtablissement>();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/compagnie.ts